import { render, staticRenderFns } from "./account-management.vue?vue&type=template&id=2a2abf9c&scoped=true"
import script from "./account-management.vue?vue&type=script&lang=js"
export * from "./account-management.vue?vue&type=script&lang=js"
import style0 from "./account-management.vue?vue&type=style&index=0&id=2a2abf9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2abf9c",
  null
  
)

export default component.exports